import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Autoplay from 'embla-carousel-autoplay';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'; // Removed CarouselNext, CarouselPrevious
import { Button } from '@/components/ui/button';

export const HeroCarousel = () => {
  const plugin = React.useRef(
    Autoplay({ delay: 2000, stopOnInteraction: false })
  );

  // [NEW] State to track the carousel API and current slide index
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);

  // [NEW] Effect to sync state with carousel events
  useEffect(() => {
    if (!api) {
      return;
    }

    // Set initial state
    setCurrent(api.selectedScrollSnap());

    // Update state on slide change
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);

  const slides = [
    {
      image: 'https://images.pexels.com/photos/6784871/pexels-photo-6784871.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      title: 'Winter Essentials',
      subtitle: 'Stay Warm & Stylish',
      cta: 'Explore Collection',
      link: '/products?tag=winter',
    },
    {
      image: 'https://images.pexels.com/photos/3087022/pexels-photo-3087022.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      title: 'New Arrivals',
      subtitle: 'Fresh Styles Just Dropped',
      cta: 'Shop Now',
      link: '/products?is_new=true',
    },
    {
      image: 'https://images.pexels.com/photos/7184358/pexels-photo-7184358.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      title: 'Anime Fandom',
      subtitle: 'Express Your Style',
      cta: 'Discover More',
      link: '/products?tag=anime',
    },
  ];

  return (
    <div className="w-full relative group" data-testid="hero-carousel">
      <Carousel
        plugins={[plugin.current]}
        setApi={setApi} // [NEW] Capture the API instance
        className="w-full"
        opts={{
          loop: true,
        }}
      >
        <CarouselContent>
          {slides.map((slide, index) => (
            <CarouselItem key={index}>
              <div className="relative h-[400px] md:h-[600px] overflow-hidden will-change-transform">
                <img
                  src={slide.image}
                  alt={slide.title}
                  loading="eager"
                  className="w-full h-full object-cover transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent flex items-center">
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                    <div className="max-w-xl space-y-4">
                      <h1 className="font-outfit font-bold text-4xl md:text-6xl lg:text-7xl text-white tracking-tight">
                        {slide.title}
                      </h1>
                      <p className="text-lg md:text-xl text-white/90">
                        {slide.subtitle}
                      </p>
                      <Link to={slide.link}>
                        <Button
                          className="rounded-full px-8 py-6 bg-primary text-primary-foreground hover:bg-primary/90 font-bold"
                          data-testid={`hero-cta-${index}`}
                        >
                          {slide.cta}
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        {/* Removed CarouselPrevious and CarouselNext */}
      </Carousel>

      {/* [NEW] Dots Navigation positioned absolutely at the bottom */}
      <div className="absolute bottom-6 left-0 right-0 flex justify-center gap-2 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => api?.scrollTo(index)}
            aria-label={`Go to slide ${index + 1}`}
            className={`transition-all duration-300 rounded-full ${
              current === index 
                ? "bg-white w-8 h-2"  // Active dot: wider and white
                : "bg-white/50 w-2 h-2 hover:bg-white/75" // Inactive dot: small circle and transparent
            }`}
          />
        ))}
      </div>
    </div>
  );
};